module.exports = __webpack_public_path__ + "media/images/lb/673-e818b7e726826f541879e4e1145203d1.svg";